export const FieldErrors = {
  resetPassNewPass: {
    required: 'New password is required.',
    minlength: 'Password must have 8 characters minimum.'
  },

  // users
  newUserFirstName: {
    required: 'Please enter the user’s first name.',
    pattern: 'Please enter a valid first name.',
    maxlength: 'First name must have less than 45 characters.',
    minlength: 'First name must have more than 2 characters.'
  },
  newUserLastName: {
    required: 'Please enter the user’s last name.',
    pattern: 'Please enter a valid last name.',
    maxlength: 'Last name must have less than 45 characters.',
    minlength: 'Last name must have more than 2 characters.'
  },
  newUserEmail: {
    required: 'Please enter the user’s email address.',
    email: 'Please use full email address with @ sign and domain.'
  },
  newUserJob: {
    required: 'Please enter the user’s job title.',
    pattern: 'Please enter a valid job title.',
    minlength: 'Job title must have more than 2 characters.'
  },
  newUserPhone: {
    required: 'Please enter the user’s mobile phone number.',
    invalidPhone: 'Please enter a valid phone number.'
  },
  newUserWorkPhone: {
    required: 'Please enter the user’s work phone number.',
    invalidPhone: 'Please enter a valid phone number.'
  },
  newUserRole: {
    required: 'Please select an access level for the user.'
  },
  changePassFormCurrentPassword: {
    required: 'Please enter current password.'
  },

  // logins
  newLoginFirstName: {
    required: 'Please enter the first name for the login.',
    pattern: 'Please enter a valid first name.',
    maxlength: 'First name must have less than 45 characters.'
  },
  newLoginLastName: {
    required: 'Please enter the last name for the login.',
    pattern: 'Please enter a valid last name.',
    maxlength: 'Last name must have less than 45 characters.'
  },
  newLoginEmail: {
    required: 'Please enter the email address for the login.',
    email: 'Please use full email address with @ sign and domain.'
  },
  newLoginPhone: {
    invalidPhone: 'Please enter a valid phone number.'
  },
  newLoginRelationship: {
    required:
      'Please enter the relationship between the person the login is for and the primary contact for the home.'
  },
  changePassFormCurrentPasswordForLogin: {
    required: 'Please enter current password.'
  },

  // change password
  changePassFormNewPassword: {
    required: 'Please enter a new password.',
    minlength: 'Password must have 8 characters minimum.',
    sameAsOld: 'New password cannot be the same as old password.',
    mustMatch: 'New passwords do not match.'
  },
  changePassFormConfirmPassword: {
    required: 'Please confirm new password.',
    minlength: 'Password must have 8 characters minimum.',
    sameAsOld: 'New password cannot be the same as old password.',
    mustMatch: 'New passwords do not match.'
  },

  // division form
  divisionName: {
    required: "Please enter the name of the Builder's Division.",
    pattern: 'Please enter a valid division name.',
    maxlength: 'Division name must have less than 45 characters.',
    minlength: 'Division name must have more than 2 characters.'
  },
  divisionUrl: {
    required: 'Please enter the website URL for the Builder’s Division.',
    pattern: 'Please enter a valid website URL address.'
  },
  divisionAddress: {
    required: "Please enter the street address of the Builder's Division.",
    pattern: 'Please enter a valid street address.',
    minlength: 'Address must have more than 2 characters.'
  },
  divisionCity: {
    required: "Please enter the city of the Builder's Division.",
    pattern: 'Please enter a valid city.',
    minlength: 'City must have more than 2 characters.'
  },
  divisionState: {
    required: "Please select the state of the Builder's Division."
  },
  divisionZipCode: {
    required: "Please enter the postal code of the Builder's Division.",
    invalidZip: 'Please enter a valid postal code.',
    pattern: 'Please enter a valid postal code.'
  },
  divisionCountry: {
    required: "Please select the country of the Builder's Division."
  },
  divisionPhone: {
    required: "Please enter the main phone number for the Builder's Division.",
    invalidPhone: 'Please enter a valid phone number.'
  },
  divisionPrimaryContact: {
    required: "Please select the Primary Contact for the Builder's Division."
  },
  divisionPrimaryContactEmailAddress: {
    required: "Please enter the email address of the Builder's primary contact for this Division.",
    email: 'Please enter a valid email address.'
  },
  divisionPrimaryContactPhone: {
    required: "Please enter the phone number of the Builder's primary contact for this Division.",
    invalidPhone: 'Please enter a valid phone number.'
  },
  divisionDesignStudioUrl: {
    required: 'Please enter the design studio URL address.',
    pattern: 'Please enter a valid URL address.'
  },
  division149PhotosId: {
    required: 'Please enter the 149Photos ID.',
    pattern: 'Please enter a valid 149Photos ID.'
  },

  // communities
  communityName: {
    required: 'Community Name is required.',
    pattern: 'Please enter a valid community name.',
    minlength: 'Community name must have more than 2 characters.',
    maxlength: 'Community name must have less than 45 characters.'
  },
  communityDivision: {
    required: 'Please Provide Division for Community.'
  },
  communityAddress: {
    required: 'Please enter the street address of the community`s physical address.',
    pattern: 'Please enter a valid street address.',
    minlength: 'Address must have more than 2 characters.'
  },
  communityCity: {
    required: 'Please enter the city of the community`s physical address.',
    pattern: 'Please enter a valid city.',
    minlength: 'City must have more than 2 characters.'
  },
  communityState: {
    required: 'Please select the state/province of the community`s physical address.'
  },
  communityZipCode: {
    required: 'Please enter the postal code of the community`s physical address.',
    invalidZip: 'Please enter a valid postal code.',
    pattern: 'Please enter a valid postal code.'
  },

  // event form
  eventName: {
    required: 'Event Name is required.',
    pattern: 'Please enter a valid event name.',
    maxlength: 'Event name must have less than 45 characters.',
    minlength: 'Event name must have more than 2 characters.'
  },
  eventDescription: {
    required: 'Please provide a description of the event.',
    maxlength: 'Description must have less than 1000 characters.'
  },

  // contacts
  contactCompany: {
    required: 'Please select the contact’s company.'
  },
  contactCompanyName: {
    required: 'Please enter the company name.',
    pattern: 'Please enter a valid company name.',
    minlength: 'Company name must have more than 2 characters.',
    maxlength: 'Company name must have less than 45 characters.'
  },
  contactCompanyState: {
    required: 'Please select the company state.'
  },
  contactUser: {
    required: 'Please select the user connected to contact.'
  },
  contactFirstName: {
    required: 'Please enter the contact’s first name.',
    pattern: 'Please enter a valid first name.',
    maxlength: 'First name must have less than 45 characters.',
    minlength: 'First name must have more than 2 characters.'
  },
  contactLastName: {
    required: 'Please enter the contact’s last name.',
    pattern: 'Please enter a valid last name.',
    maxlength: 'Last name must have less than 45 characters.',
    minlength: 'Last name must have more than 2 characters.'
  },
  contactEmail: {
    required: 'Please enter the contact’s email address.',
    email: 'Please use full email address with @ sign and domain.'
  },
  contactJob: {
    required: 'Please enter the contact’s job title.',
    pattern: 'Please enter a valid job title.',
    minlength: 'Job title must have more than 2 characters.'
  },
  contactPhone: {
    required: 'Please enter the contact’s mobile phone number.',
    invalidPhone: 'Please enter a valid phone number.'
  },
  contactWorkPhone: {
    required: 'Please enter the contact’s work phone number.',
    invalidPhone: 'Please enter a valid phone number.'
  },
  contactType: {
    required: 'Please select the contact’s type.'
  },
  contactDescription: {
    required: 'Please enter the contact’s description.',
    maxlength: 'Description must have less than 1000 characters.'
  },
  contactGroupName: {
    required: 'Please enter the contact group name.',
    minlength: 'Contact group name must have more than 2 characters.',
    maxlength: 'Contact group name must have less than 45 characters.'
  },
  contactGroupMembersNames: {
    required: 'Please enter the contact group members names.'
  },
  // contact types
  contactTypeName: {
    required: 'Please enter the contact type name.',
    pattern: 'Please enter a valid contact type name',
    maxlength: 'Contact type name must have less than 45 characters.',
    minlength: 'Contact type name must have more than 2 characters.'
  },
  contactTypeDescription: {
    required: 'Please enter the contact type description.',
    maxlength: 'Description must have less than 1000 characters.',
    minlength: 'Description must have more than 2 characters.'
  },
  // phase form
  phaseName: {
    required: "Please enter the phase's name.",
    pattern: "Please enter a valid phase's name.",
    minlength: 'Phase name must have more than 2 characters.',
    maxlength: 'Phase name must have less than 45 characters.'
  },
  phaseDescription: {
    required: "Please enter the phase's description.",
    maxlength: 'Description must have less than 1000 characters.'
  },
  phaseVideoUrl: {
    pattern: 'Please enter a valid video URL address.'
  },

  // phase tip form
  phaseTipName: {
    required: 'Please enter the name for the phase tip.',
    pattern: 'Please enter a valid phase tip name.',
    minlength: 'Phase tip name must have more than 2 characters.',
    maxlength: 'Phase tip name must have less than 45 characters.'
  },
  phaseTipDescription: {
    required: "Please enter the phase tip's description.",
    maxlength: 'Description must have less than 1000 characters.'
  },

  // Home form
  homeDivision: {
    required: 'Please select the applicable division for the home.'
  },
  homeCommunity: {
    required: 'Please select the applicable community for the home.'
  },
  homePlan: {
    required: 'Please select the applicable plan for the home.'
  },
  homeElevation: {
    required: 'Please select the applicable elevation for the home.'
  },
  homeHomesite: {
    required: 'Please enter the homesite / lot number for the home.',
    pattern: 'Please enter a valid homesite / lot number.'
  },
  homeElevationRendering: {
    required: 'Please upload an elevation rendering for the home.'
  },
  homeAddress: {
    required: 'Please enter the street address of the home`s physical address.',
    pattern: 'Please enter a valid street address.',
    minlength: 'Street address must have more than 2 characters.'
  },
  homeCity: {
    required: 'Please enter the city of the home`s physical address.',
    pattern: 'Please enter a valid city.',
    minlength: 'City must have more than 2 characters.'
  },
  homeState: {
    required: 'Please select the state/province of the home`s physical address.'
  },
  homeZipCode: {
    required: 'Please enter the postal code of the home`s physical address.',
    invalidZip: 'Please enter a valid postal code.',
    pattern: 'Please enter a valid postal code.'
  },
  homeBuyerFirstName: {
    required: 'Please enter the first name of the primary buyer for the home.',
    pattern: 'Please enter a valid first name.',
    maxlength: 'First name must have less than 45 characters.'
  },
  homeBuyerLastName: {
    required: 'Please enter the last name of the primary buyer for the home.',
    pattern: 'Please enter a valid last name.',
    maxlength: 'Last name must have less than 45 characters.'
  },
  homeBuyerEmail: {
    required: 'Please enter the email address of the primary buyer for the home.',
    email: 'Please use full email address with @ sign and domain.'
  },
  homeBuyerPhone: {
    required: 'Please enter the phone number of the primary buyer for the home.',
    invalidPhone: 'Please enter a valid phone number.'
  },
  homeCoBuyerFirstName: {
    pattern: 'Please enter a valid first name.',
    minlength: 'First Name must have more than 2 characters.',
    maxlength: 'First name must have less than 45 characters.'
  },
  homeCoBuyerLastName: {
    pattern: 'Please enter a valid last name.',
    minlength: 'Last Name must have more than 2 characters.',
    maxlength: 'First name must have less than 45 characters.'
  },
  homeContractDate: {
    required: 'Please select the contract date for the home.'
  },
  timeZone: {
    required: 'Please select the time zone for the division.'
  },

  homePhase: {
    required: 'Please select the phase for the home.'
  },

  planName: {
    required: "Please enter the plan's name.",
    pattern: "Please enter a valid plan's name.",
    minlength: 'Plan name must have more than 2 characters.',
    maxlength: 'Plan name must have less than 45 characters.'
  },

  elevationName: {
    required: "Please enter the elevation's name",
    pattern: "Please enter a valid elevation's name",
    minlength: 'Elevation name must have more than 2 characters.',
    maxlength: 'Elevation name must have less than 45 characters.'
  },

  phaseByCommunityAssignment: {
    required: 'Please select the phase.',
    divisionMismatch: 'Please select at least one phase for each selected division.'
  },

  documentName: {
    required: "Please enter document's name.",
    maxlength: 'Document name must have less than 45 characters.',
    minlength: 'Document name must have more than 2 characters.'
  },
  documentDescription: {
    required: "Please enter document's description.",
    maxlength: 'Description must have less than 1000 characters.',
    minlength: 'Document description must have more than 2 characters.'
  },
  documentPhases: {
    required: 'Please select one or more phases to apply this document to.'
  },

  // common
  email: 'Please use full email address with @ sign and domain.',
  required: 'This field is required.',
  password: 'Password should be at least 8 characters.',
  streetAddress: {
    required: 'Please enter a valid street address.',
    pattern: 'Please enter a valid street address.',
    minlength: 'Street address must have more than 2 characters.'
  },
  city: {
    required: 'Please enter a valid city.',
    pattern: 'Please enter a valid city.',
    minlength: 'City must have more than 2 characters.'
  },
  state: {
    required: 'Please select a province or state.'
  },
  zip: {
    required: 'Please enter a valid postal code',
    invalidZip: 'Please enter a valid postal code',
    pattern: 'Please enter a valid postal code'
  },
  homeSchedule: {
    required: 'This field is required.'
  },
  homeSchedulePhase: {
    required: 'Please select the phase for this home.'
  },
  homeScheduleEvent: {
    required: 'Please select the event.'
  },
  homeScheduleEventName: {
    required: 'Please enter the event name.',
    pattern: 'Please enter a valid event name. ',
    minlength: 'Event name must have more than 2 characters.',
    maxlength: 'Event name must have less than 45 characters.'
  },
  homeScheduleDescription: {
    required: 'Please provide a description of the event.',
    maxlength: 'Name must have less than 1000 characters.'
  },
  homeScheduleDate: {
    required: 'Please enter a date of the event.'
  },
  homeScheduleStartTime: {
    required: 'Please enter a start time.'
  },
  homeScheduleEndTime: {
    required: 'Please enter an end time.',
    invalidRange: 'Start time should be less than end time.'
  },
  homeScheduleInvitees: {
    required: 'Please select the invitees for the event.',
    buyersRequired: 'Please select at least one buyer.',
    contactsRequired: 'Please select the contact.'
  },
  homeScheduleStreetAddressFirst: {
    required: 'Please enter the first location street address.',
    pattern: 'Please enter a valid street address.',
    minlength: 'Street address must have more than 2 characters.'
  },
  homeScheduleStreetAddressSecond: {
    required: 'Please enter the second location street address.',
    pattern: 'Please enter a valid street address.',
    minlength: 'Street address must have more than 2 characters.'
  },
  homeScheduleCity: {
    required: 'Please enter the city of the home`s physical address.',
    pattern: 'Please enter a valid city.',
    minlength: 'City must have more than 2 characters.'
  },
  homeScheduleState: {
    required: 'Please select the state/province of the home`s physical address.'
  },
  homeScheduleZipCode: {
    required: 'Please enter the state/province of the home`s physical address.',
    invalidZip: 'Please enter a valid postal code.',
    pattern: 'Please enter a valid postal code.'
  },
  homeScheduleRequestedBy: {
    required: 'Please choose requested by.'
  }
};
